export default "__VITE_ASSET__iXZmAjjs__"